import type { FilterDefinition } from '@factorialco/f0-react/dist/experimental'

import i18n from 'modules/core/lib/i18n'

export const approvedAtFilter = (): FilterDefinition => ({
  label: i18n.t('expenses_v2.list.header.approved_at'),
  type: 'date',
  options: {
    mode: 'range',
  },
})
